"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
const faqs = [{
  question: "Wanneer word ik uitbetaald voor mijn installatiewerkzaamheden?",
  answer: "Bij SOLARIX begrijpen we dat cashflow essentieel is voor ZZP'ers. Daarom hanteren wij een snelle betalingstermijn van 14 dagen na oplevering en digitale goedkeuring van de klus. Geen gedoe met lange wachttijden, zodat jij direct weer kunt investeren in je eigen onderneming."
}, {
  question: "Wie is verantwoordelijk voor de levering van materialen op de klus?",
  answer: "Wij ontzorgen je volledig op logistiek gebied. SOLARIX regelt dat alle benodigde materialen — van zonnepanelen en omvormers tot thuisbatterijen en montagemateriaal — tijdig op de projectlocatie aanwezig zijn. Jij hoeft enkel je eigen gereedschap, klimmateriaal en vakmanschap mee te nemen."
}, {
  question: "Hoe krijg ik toegang tot nieuwe projecten en de planning?",
  answer: "Zodra je als partner bent aangemeld, krijg je toegang tot ons planningsoverzicht. Hier zie je alle beschikbare klussen bij jou in de regio. Je kunt zelf reageren op projecten die in jouw agenda passen, waardoor je volledige controle houdt over je eigen werkweek en bezettingsgraad."
}, {
  question: "Zijn de technische schouwingen en legplannen al voorbereid?",
  answer: "Absoluut. Onze eigen engineers voeren vooraf de technische schouwing uit en maken een gedetailleerd legplan of installatieschema. Je ontvangt alle specificaties digitaal via onze app, zodat je op de dag van installatie precies weet wat de bedoeling is en direct efficiënt aan de slag kunt."
}, {
  question: "Aan welke certificeringseisen moet ik voldoen als onderaannemer?",
  answer: "Veiligheid en kwaliteit staan bij ons voorop. We verwachten dat onze partners beschikken over een geldig VCA-certificaat en aantoonbare ervaring in de duurzame techniek. Voor specifieke installaties zoals warmtepompen of complexe elektra vragen we relevante certificeringen zoals F-gassen of InstallQ."
}];
export default function ExpertCommentaryFaq() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="223711" id="veelgestelde-vragen" className="bg-background text-foreground py-24 relative overflow-hidden border-t border-border/20">
      {}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-[1000px] h-[500px] bg-primary/5 blur-[150px] rounded-full pointer-events-none" />

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10 max-w-4xl">
        <div ref={ref} className={`transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          <div className="mb-12 text-center md:text-left">
            <h2 className="text-3xl md:text-4xl font-default font-bold mb-4 tracking-tight text-foreground">
              Veelgestelde <span className="text-primary">vragen</span>
            </h2>
            <p className="text-muted-foreground font-sans text-lg max-w-2xl">Duidelijkheid over betalingen, materialen en planning. Alles wat je als installatiepartner moet weten over de samenwerking met CL Installatie.</p>
          </div>

          <Accordion type="single" collapsible className="w-full space-y-4">
            {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="border border-border/30 bg-card/40 backdrop-blur-sm rounded-lg px-2 overflow-hidden transition-all duration-300 hover:border-primary/50 hover:bg-card/60 hover:shadow-md">
                <AccordionTrigger className="hover:no-underline py-5 px-4 group">
                  <div className="flex items-start text-left gap-4">
                    <span className="font-mono text-primary/80 text-xs mt-1 tracking-widest shrink-0">
                      {(i + 1).toString().padStart(2, "0")}
                    </span>
                    <span className="font-default font-bold text-base leading-snug group-hover:text-primary transition-colors">
                      {faq.question}
                    </span>
                  </div>
                </AccordionTrigger>
                <AccordionContent className="px-4 pb-6 pt-2 pl-12 text-muted-foreground font-sans leading-relaxed text-sm md:text-base border-t border-border/10 mt-2">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>
        </div>
      </div>
    </section>;
}